import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
  private _isMobile: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private _isTablet: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private _isDesktop: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private _resize: Subject<any> = new Subject<any>();

  public isMobile$ = this._isMobile.asObservable();
  public isTablet$ = this._isMobile.asObservable();
  public isDesktop$ = this._isMobile.asObservable();
  public resize$ = this._resize.asObservable();

  constructor(private _breakpointObserver: BreakpointObserver) {
    this._breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium,
      Breakpoints.Large,
      Breakpoints.XLarge
    ]).subscribe( (state: BreakpointState) => {
      if (state.breakpoints[Breakpoints.XSmall] || state.breakpoints[Breakpoints.Small]) {
        this.setIsMobile(true);
      } else if (state.breakpoints[Breakpoints.Medium] || state.breakpoints[Breakpoints.Large] || state.breakpoints[Breakpoints.XLarge]) {
        this.setIsDesktop(true);
      }
      this._resize.next();
    });
  }

  public setIsMobile(value: true) {
    this._isMobile.next(value);
    if (!value) {
      this._isTablet.next(false);
      this._isDesktop.next(false);
    }
  }

  public setIsTablet(value: true) {
    this._isTablet.next(value);
    if (value) {
      this._isMobile.next(false);
      this._isDesktop.next(false);
    }
  }

  public setIsDesktop(value: true) {
    this._isDesktop.next(value);
    if (value) {
      this._isMobile.next(false);
      this._isTablet.next(false);
    }
  }
}
